











































import axios from 'axios';
import env from '@/env';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Module, Responsible } from '@/types';

@Component({})
export default class ResponsibleSettingsDialog extends Vue {
  @Prop({ default: () => false })
  value!: boolean;

  @Prop({ default: () => ({ exclude_from_steps: false, prioritized_modules: [] }) })
  responsible!: Responsible;

  blueprints: Module[] = [];

  submit() {
    this.$emit('close');
  }

  async created() {
    const { data } = await axios.get(`${env.backend_url}/module/blueprints/all`);
    this.blueprints = data;
  }
}
